import equineLeftSideImage from '../../ImageDiagnosis/diagnosisImages/assets/equine-leftside.png';
import equineRightSideImage from '../../ImageDiagnosis/diagnosisImages/assets/equine-rightside.png';
import { DxImageWithPointsAndConditions } from '../imageDxTypes';
import {
  orthopedicOa,
  orthopedicOther,
  navicular,
  tendinopathy,
  neurological,
  sacroiliacDisease,
  odsp
} from '../painConditions';

// equinePainSimpleDxImages is the list of image (right and left sides) with all points for the equine pain diagnosis.
export const equinePainSimpleDxImages: DxImageWithPointsAndConditions[] = [
  {
    name: 'Right Side',
    imageUrl: equineRightSideImage,
    points:  [
        {
          label: "neck",
          name: "neck",
          x: 489,
          y: 164,
          conditions: [orthopedicOa, orthopedicOther, neurological]
        },
        {
          label: "Back",
          name: "back",
          x: 284,
          y: 170,
          conditions: [orthopedicOa, orthopedicOther, neurological, odsp, sacroiliacDisease]
        },
        {
          label: "Right Back Limb",
          name: "right_back_limb",
          x: 217,
          y: 338,
          conditions: [orthopedicOa, orthopedicOther, tendinopathy, navicular]
        },
        {
          label: "Right Front Limb",
          name: "right_front_limb",
          x: 428,
          y: 338,
          conditions: [orthopedicOa, orthopedicOther, tendinopathy, navicular] 
        },
        
    ],
  },
  {
    name: 'Left Side',
    imageUrl: equineLeftSideImage,
    points: [
        {
            label: "Neck",
            name: "neck",
            x: 179,
            y: 164,
            conditions: [orthopedicOa, orthopedicOther, neurological]
        },
        {
            label: "Back",
            name: "back",
            x: 370,
            y: 170,
            conditions: [orthopedicOa, orthopedicOther, neurological, odsp, sacroiliacDisease]
        },
        {
          label: "Left Back Limb",
          name: "left_back_limb",
          x: 456,
          y: 338,
          conditions: [orthopedicOa, orthopedicOther, tendinopathy, navicular]
        },
        {
            label: "Left Front Limb",
            name: "left_front_limb",
            x: 239,
            y: 338,
            conditions: [orthopedicOa, orthopedicOther, tendinopathy, navicular]
        }
    ]
  }
];
